import React, { useCallback, useRef, useEffect } from 'react';
import { map } from 'rxjs/operators';
import { useFormContext, useController } from 'react-hook-form';
import { Subscription } from 'rxjs';
import { debounce } from 'lodash';
import * as personService from '@api/person';
import CircularProgress from '@material-ui/core/CircularProgress';
import { TextField, FormHelperText, Button } from '@material-ui/core';
import { Grid, Chip, Link, Avatar, Select, FormControl, InputLabel } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import MovieCreationIcon from '@material-ui/icons/MovieCreation';
import OfflinePinIcon from '@material-ui/icons/OfflinePin';
import { Autocomplete } from '@material-ui/lab';
import PersonDefaultIcon from '@icon/person-default';
import * as personManagementService from '@api/person-management';
import {
  Dialog,
  DialogActions,
  DialogTitle
} from '@material-ui/core';
import * as companyService from '@api/company';
import { useSnackbar } from 'notistack';
import * as rolesService from '@api/person/designation';

export function AssociatedPersonSearch({
  associatedPerson,
  setAssociatedPerson,
  multiple = false,
  label = 'Associated Person',
  associatedCompany,
  setAssociatedCompany,
  company,
  setCompany,
  freeSolo = true,
  showCompany = false,
  loadingCompanies = false,
  createCompanyRelation = false
}) {
  const classesForAvatarImage = useStyles();
  const lastSubscription = useRef<Subscription>(null);
  const lastSearchedvalue = useRef<string>(null);

  const [open, setOpen] = React.useState(false);
  const [openPersonForm, setOpenPersonForm] = React.useState(false);
  const [openSearchCompanyForm, setOpenSearchCompanyForm] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [optionsCompany, setOptionsCompany] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [companyLoading, setCompanyLoading] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [personCount, setPersonCount] = React.useState(null);
  const [person, setPerson] = React.useState({})
  const [personName, setPersonName] = React.useState('')
  // const [company, setCompany] = React.useState({});
  const onChangeHandle = useCallback(value => {
    if (lastSearchedvalue.current && lastSearchedvalue.current == value && options.length > 0) {
      setOptions(prevOptions => [...prevOptions]);
      return;
    }
    setOptions([]);
    lastSearchedvalue.current = value;
    if (lastSubscription.current) {
      lastSubscription.current.unsubscribe();
    }
    setLoading(true);
    setAssociatedPerson(value);
    setOpen(true);
    lastSubscription.current = personService
      .personSearch({
        searchKey: 'name',
        query: value,
        pageSize: 150,
      })
      .pipe(
        map(res => ({
          ...res.data,
          data: res.data.data.map(d => {
            const reqdData = { ...d, id: d.vtr_id, person_vtr_id: d.vtr_id };
            delete reqdData.vtr_id;
            return reqdData;
          }),
        }))
      )
      .subscribe({
        next: data => {
          setOptions(data.data);
          setPersonCount(data.count);
        },
        error: data => {
          console.error(data, 'Error');
        },
        complete: () => {
          setLoading(false);
        },
      });
  }, []);
  const debouncedOnChangeHandle = useCallback(
    debounce(value => onChangeHandle(value), 2000),
    [onChangeHandle]
  );
  const showModal = () => {
    setOpenPersonForm(true);

    setOpen(false)
    // onClose()
  }

  const showCompanyForm = () => {
    setOpenSearchCompanyForm(true);
    setOpen(false);
  }
  const setPersonData1 = (data) => {
    setPerson(data);
    setAssociatedPerson(data);
  }

  const setCompanyData1 = (data) => {
    setCompany(data)
    setAssociatedCompany([data])
  }
  const setOpenPersonForm1 = () => {
    setOpenPersonForm(false)
  }

  const setOpenCompanyForm1 = () => {
    setOpenSearchCompanyForm(false)
  }

  /* const saveAssociatedPersonToCompany = () => {
    console.log({ "associated_company": associatedCompany });
    console.log({ "associated_person": associatedPerson });
  } */

  const onChangeHandleCompany = useCallback(value => {
    if (lastSearchedvalue.current && lastSearchedvalue.current == value && optionsCompany.length > 0) {
      setOptionsCompany(prevOptions => [...prevOptions]);
      return;
    }
    setOptionsCompany([]);
    lastSearchedvalue.current = value;
    if (lastSubscription.current) {
      lastSubscription.current.unsubscribe();
    }
    setCompanyLoading(true);
    lastSubscription.current = companyService
      .filter_add_entity({
        filters: [{
          id: 'vtr_company_name',
          value: {
            $contains: value,
          },
        }
        ],
      })
      .pipe(
        map(res => ({
          count: res.data.count,
          data: res.data.data.map(d => ({
            ...d,
            id: d.vtr_id,
            company: d.vtr_id,
            company_vtr_id: d.vtr_id,
            name: d.vtr_company_name,
            projects_count: d.deal_content_count.content_count,
            reputation: d.deal_content_count.reputation,
            connections: d.deal_content_count.connections,
            deals: d.deal_content_count.deal_count,
            country_names: d.hqcountry,
            company_type: (d.company_types || []).map(t => t.name).join(', '),
          })),
        }))
      )
      .subscribe({
        next: data => {
          setOptionsCompany(data.data);
          setPersonCount(data.count);
        },
        error: data => {
          console.error(data, 'Error');
        },
        complete: () => {
          setCompanyLoading(false);
        },
      });
  }, []);

  const debouncedOnChangeHandleCompany = useCallback(
    debounce(value => onChangeHandleCompany(value), 2000),
    [onChangeHandleCompany]
  );



  return (
    <>
      {createCompanyRelation && <><br/><br/></>}
      <Autocomplete
        fullWidth
        freeSolo
        multiple={multiple}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        disableClearable
        getOptionLabel={option => (typeof option === 'object' ? option?.name : option)}
        options={options}
        renderTags={(tagValue, getTagProps) => {
          return tagValue.map((option, index) => (
            <Chip
              label={typeof option === 'object' ? option?.name : option}
              icon={
                typeof option === 'object' && option?.person_vtr_id ? (
                  <OfflinePinIcon style={{ fontSize: '1.5em' }} color="primary" />
                ) : null
              }
              {...getTagProps({ index })}
              color="secondary"
            />
          ));
        }}
        renderOption={option => (
          <Grid container alignItems="center">
            <Grid item xs={1}>
              <Avatar
                className={classesForAvatarImage.medium}
                alt={option?.name}
                src={`https://image.tmdb.org/t/p/w92${option?.profile_path}`}>
                <PersonDefaultIcon />
              </Avatar>
            </Grid>
            <Grid item xs={5}>
              {option?.name}
            </Grid>
            <Grid item xs={3}>
              {option?.role_id}
            </Grid>
            {option?.imdb_id && (
              <Grid item xs={3}>
                <>
                  <Chip
                    color="primary"
                    size="small"
                    icon={<MovieCreationIcon fontSize="inherit" />}
                    component={Link}
                    href={`https://www.imdb.com/name/${option?.imdb_id}`}
                    target="_blank"
                    label="IMDB"
                  />
                </>
              </Grid>
            )}

            {option?.person_tmdb_id && (
              <Grid item xs={3}>
                <>
                  <Chip
                    size="small"
                    color="secondary"
                    label={`TMDB`}
                    icon={<MovieCreationIcon fontSize="inherit" />}
                    component={Link}
                    href={`https://www.themoviedb.org/person/${option.person_tmdb_id}`}
                    target="_blank"
                  />
                </>
              </Grid>
            )}
          </Grid>
        )}
        loading={loading}
        loadingText={
          'Searching ... '
        }
        value={associatedPerson}
        onChange={(evt, v) => setAssociatedPerson(v)}
        onInputChange={(evt, v) => {
          if (freeSolo) {
            if (!multiple) {
              if (associatedPerson) {
                if (associatedPerson.name !== v) setAssociatedPerson(v);
              } else {
                setAssociatedPerson(v);
              }
            }
          }
        }}
        renderInput={props => (
          <TextField
            label={createCompanyRelation ? "Select a Person" : label}
            placeholder={label}
            fullWidth
            variant="outlined"
            {...props}
            onChange={ev => {
              setPersonName(ev.target.value);
              if (!!ev.target.value) {
                debouncedOnChangeHandle(ev.target.value);
              }
            }}
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <>
                      <CircularProgress color="inherit" size={20} />
                      {props.InputProps.endAdornment}
                    </>
                  ) : associatedPerson && associatedPerson.person_vtr_id ? (
                    <>
                      {props.InputProps.endAdornment}
                      {setOpen(false)}
                      <OfflinePinIcon style={{ fontSize: '1.5em' }} color="primary" />
                    </>
                  ) : null}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
      <div
        className={
          personCount == 0
            ? open
              ? classesForAvatarImage.personStatus
              : classesForAvatarImage.personStatus1
            : ''
        }>
        <PersonStatus style={{ marginTop: "0 !important" }} personData={personCount} person_name={associatedPerson} showModal={showModal} createCompanyRelation={createCompanyRelation}/>
      </div>
      <br />
      <div hidden={!showCompany}>
        {!createCompanyRelation && <FormControl variant="outlined" fullWidth>
          <InputLabel id="company-label">{loadingCompanies ? 'Loading companies...' : 'Select a company'}</InputLabel>

          <Select
            labelId="company"
            id="company"
            name="company"
            native
            label="Select a company"
            value={company?.company || (company ? company : '')}
            defaultValue={company?.company || company}
            disabled={createCompanyRelation ? false : loadingCompanies}
            onChange={e => setCompany(e.target.value)}>

            <option value=""></option>
            {associatedCompany &&
              associatedCompany?.map(res => {
                return (
                  <option key={res.company_vtr_id} value={res.company_vtr_id}>
                    {res.name}
                  </option>
                );
              })}
          </Select>
          {!createCompanyRelation && <FormHelperText>
            No Associated company found? <Link component='button' onClick={() => showCompanyForm()}>Create Association</Link>
          </FormHelperText>}
        </FormControl>}
        {createCompanyRelation && <Autocomplete
        fullWidth
        freeSolo={true}
        multiple={false}
        open={open1}
        onOpen={() => {
          setOpen1(true);
        }}
        onClose={() => {
          setOpen1(false);
        }}
        style={{ 'padding': 0}}
        disableClearable
        getOptionLabel={option => (typeof option === 'object' ? option.vtr_company_name : option)}
        options={optionsCompany}
        renderTags={(tagValue, getTagProps) => {
          return tagValue.map((option, index) => (
            <Chip
              label={typeof option === 'object' ? option.vtr_company_name : option}
              icon={
                typeof option === 'object' && option.vtr_company_name ? (
                  <OfflinePinIcon style={{ fontSize: '1.5em' }} color="primary" />
                ) : null
              }
              {...getTagProps({ index })}
              color="secondary"
            />
          ));
        }}
        renderOption={option => (
          <Grid container alignItems="center">
            <Grid item xs={1}>
              <Avatar
                className={classesForAvatarImage.medium}
                alt={option.vtr_company_name}
                src={`https://image.tmdb.org/t/p/w92${option.profile_path}`}>
                <PersonDefaultIcon />
              </Avatar>
            </Grid>
            <Grid item xs={3}>
              {option?.vtr_company_name}
            </Grid>
            <Grid item xs={3}>
              {option?.company_types?.filter(ele => ele?.order_id == 1)?.[0]?.['name']}
            </Grid>
            <Grid item xs={2}>
              {option?.hqcountry}
            </Grid>

            {option?.imdb_id && (
              <Grid item xs={3}>
                <>
                  <Chip
                    color="primary"
                    size="small"
                    icon={<MovieCreationIcon fontSize="inherit" />}
                    component={Link}
                    href={`https://www.imdb.com/name/${option?.imdb_id}`}
                    target="_blank"
                    label="IMDB"
                  />
                </>
              </Grid>
            )}

            {option?.person_tmdb_id && (
              <Grid item xs={3}>
                <>
                  <Chip
                    size="small"
                    color="secondary"
                    label="TMDB"
                    icon={<MovieCreationIcon fontSize="inherit" />}
                    component={Link}
                    href={`https://www.themoviedb.org/person/${option?.person_tmdb_id}`}
                    target="_blank"
                  />
                </>
              </Grid>
            )}
          </Grid>
        )}
        loading={companyLoading}
        loadingText={
          'Searching ... '
        }
        value={company}
        onChange={(evt, v) => setCompany(v)}
        onInputChange={(evt, v) => {
          if (freeSolo) {
            if (!multiple) {
              if (company) {
                if (company && company.vtr_company_name !== v) {
                  setCompany(v);
                }
              } else {
                setCompany(v);
              }
            }
          }
        }}
        renderInput={props => (
          <TextField
            label={"Search a Company"}
            placeholder={"Search a Company"}
            fullWidth
            variant="outlined"
            {...props}
            onChange={ev => {
              if (!!ev.target.value) {
                debouncedOnChangeHandleCompany(ev.target.value);
              }
            }}
            onFocus={ev => {
              if (!!ev.target.value) {
                debouncedOnChangeHandleCompany(ev.target.value);
              }
            }}
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <>
                      <CircularProgress color="inherit" size={20} />
                      {props.InputProps.endAdornment}
                    </>
                  ) : (company?.vtr_company_name) ? (
                    <>
                      {props.InputProps.endAdornment}
                      <OfflinePinIcon style={{ fontSize: '1.5em' }} color="primary" />
                    </>
                  ) : null}
                </React.Fragment>
              ),
            }}
          />
        )}
      />}
      </div>
      <NewPersonDialog
        open={openPersonForm}
        onClose={setOpenPersonForm1}
        setPersonData={setPersonData1}
        person_name={personName}
      />
      <SearchCompanyDialog
        open={openSearchCompanyForm}
        onClose={setOpenCompanyForm1}
        setCompanyData={setCompanyData1}
        freeSolo={true}
        multiple={false}
      />
    </>
  );
}

const ControlledAutoCompleteField = ({
  name,
  control,
  removeService = null,
  loadingBar = false,
  defaultValue = null,
  setKnownForValue = null,
  ...props
}) => {
  const {
    field: { value, onChange },
  } = useController({ name, control, defaultValue });
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    getOptionsData();
  }, []);

  const getOptionsData = () => {
    rolesService
      .rolesSearch({})
      .pipe(
        map(res => ({
          ...res.data,
          data: res.data,
        }))
      )
      .subscribe({
        next: data => {
          setOptions(data.data);
        },
        error: data => {
          console.error(data, 'Error');
        },
        complete: () => {
          setLoading(false);
        },
      });
  };

  return (
    <Autocomplete
      fullWidth
      freeSolo
      value={value}
      onChange={(evt, v) => setKnownForValue(v)}
      options={options}
      getOptionLabel={value => value}
      renderInput={props => (
        <TextField
          variant="outlined"
          label={'Known For'}
          placeholder={'Known For'}
          fullWidth
          {...props}
        />
      )}
    />
  );
};

export function NewPersonDialog({
  onDeleteFinish = null,
  onClose = null,
  open,
  setPersonData = null,
  person_name = null,
}) {
  const form = useFormContext();
  const [firstname, setFirstName] = React.useState(person_name);
  const [middlename, setMiddleName] = React.useState('');
  const [lastname, setLastName] = React.useState('');
  const [email_id, setEmailId] = React.useState('');
  const [role_id, setKnownFor] = React.useState('');
  const classes = useStyles();
  useEffect(() => {
    // update the state every time the prop.dilaogOpenProp dependency changes
    setFirstName(person_name);
  }, [person_name]);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const setValueForKnownFor = (v) => {
    setKnownFor(v)
  }
  const ClickHandler = () => {
    if (firstname !== '' && role_id !== '') {
      const infoNotification = enqueueSnackbar('Please wait Creating a Person', {
        variant: 'info',
      });
      personManagementService
        .create({
          firstname: firstname,
          middlename: middlename,
          lastname: lastname,
          role_id: role_id,
          email_id: email_id
        })
        .pipe(
          map(res => ({
            ...res.data,
            id: res.data.vtr_id,
            person_vtr_id: res.data.vtr_id,
            firstname: res.data.firstname,
            middlename: res.data.middlename,
            lastname: res.data.lastname,
            role_id: res.data.role_id,
            email_id: res.data.email_id
          }))
        )
        .subscribe({
          next: data => {
            enqueueSnackbar('Person Created Successfully!', { variant: 'success' });
            onClose()
            setPersonData(data)
          },
          error: data => {
            console.error(data, 'Error');
          },
          complete: () => {
            onClose();
            closeSnackbar(infoNotification);
          },
        });
    }
    else {
      const infoNotification = enqueueSnackbar('Person Name & Known For are required to create a person', {
        variant: 'error',
      });
    }
  };
  return (
    <Dialog
      classes={{ paper: classes.paper }}
      maxWidth="lg"
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">Create New Person</DialogTitle>
      <FormControl className={classes.inputF} variant="outlined">
        <TextField
          label="First Name"
          placeholder="First Name"
          variant="outlined"
          value={firstname}
          onChange={e => setFirstName(e.target.value)}
          inputRef={form.register}
        />
        <br />
        <TextField
          label="Middle Name"
          placeholder="Middle Name"
          variant="outlined"
          value={middlename}
          onChange={e => setMiddleName(e.target.value)}
          inputRef={form.register}
        />
        <br />
        <TextField
          label="Enter Last Name"
          placeholder="Enter Last Name"
          variant="outlined"
          value={lastname}
          onChange={e => setLastName(e.target.value)}
          inputRef={form.register}
        />
        <br />
        <TextField
          label="Email ID"
          placeholder="Email ID"
          variant="outlined"
          value={email_id}
          onChange={e => setEmailId(e.target.value)}
          inputRef={form.register}
        />
        <br />
        <ControlledAutoCompleteField
          variant="outlined"
          name={'role_id'}
          label={'Known for'}
          control={form.control}
          setKnownForValue={setValueForKnownFor}
        />
        <br />
        <DialogActions>
          <Button color="primary" onClick={ClickHandler} autoFocus>
            Save
          </Button>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </FormControl>
    </Dialog>
  );
}

export function SearchCompanyDialog({
  onDeleteFinish = null,
  onClose = null,
  open,
  setCompanyData = null,
  freeSolo = true,
  multiple = false
}) {
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [personCount, setPersonCount] = React.useState(null);
  const [company, setCompany] = React.useState(null);
  const classes = useStyles();
  const lastSubscription = useRef<Subscription>(null);
  const lastSearchedvalue = useRef<string>(null);
  const classesForAvatarImage = useStyles();
  const onChangeHandle = useCallback(value => {
    if (lastSearchedvalue.current && lastSearchedvalue.current == value && options.length > 0) {
      setOptions(prevOptions => [...prevOptions]);
      return;
    }
    setOptions([]);
    lastSearchedvalue.current = value;
    if (lastSubscription.current) {
      lastSubscription.current.unsubscribe();
    }
    setLoading(true);
    lastSubscription.current = companyService
      .filter_add_entity({
        filters: [{
          id: 'vtr_company_name',
          value: {
            $contains: value,
          },
        }
        ],
      })
      .pipe(
        map(res => ({
          count: res.data.count,
          data: res.data.data.map(d => ({
            ...d,
            id: d.vtr_id,
            company: d.vtr_id,
            company_vtr_id: d.vtr_id,
            name: d.vtr_company_name,
            projects_count: d.deal_content_count.content_count,
            reputation: d.deal_content_count.reputation,
            connections: d.deal_content_count.connections,
            deals: d.deal_content_count.deal_count,
            country_names: d.hqcountry,
            company_type: (d.company_types || []).map(t => t.name).join(', '),
          })),
        }))
      )
      .subscribe({
        next: data => {
          setOptions(data.data);
          setPersonCount(data.count);
        },
        error: data => {
          console.error(data, 'Error');
        },
        complete: () => {
          setLoading(false);
        },
      });
  }, []);
  const debouncedOnChangeHandle = useCallback(
    debounce(value => onChangeHandle(value), 2000),
    [onChangeHandle]
  );

  const ClickHandler = () => {
    setCompanyData(company);
    setOpen1(false);
    onClose();
  };

  return (
    <Dialog
      classes={{ paper: classes.paper }}
      maxWidth="lg"
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">Associate Person to Company</DialogTitle>
      <Autocomplete
        fullWidth
        freeSolo={true}
        multiple={false}
        open={open1}
        onOpen={() => {
          setOpen1(true);
        }}
        onClose={() => {
          setOpen1(false);
        }}
        style={{ 'padding': 20 }}
        disableClearable
        getOptionLabel={option => (typeof option === 'object' ? option.vtr_company_name : option)}
        options={options}
        renderTags={(tagValue, getTagProps) => {
          return tagValue.map((option, index) => (
            <Chip
              label={typeof option === 'object' ? option.vtr_company_name : option}
              icon={
                typeof option === 'object' && option.vtr_company_name ? (
                  <OfflinePinIcon style={{ fontSize: '1.5em' }} color="primary" />
                ) : null
              }
              {...getTagProps({ index })}
              color="secondary"
            />
          ));
        }}
        renderOption={option => (
          <Grid container alignItems="center">
            <Grid item xs={1}>
              <Avatar
                className={classesForAvatarImage.medium}
                alt={option.vtr_company_name}
                src={`https://image.tmdb.org/t/p/w92${option.profile_path}`}>
                <PersonDefaultIcon />
              </Avatar>
            </Grid>
            <Grid item xs={3}>
              {option?.vtr_company_name}
            </Grid>
            <Grid item xs={3}>
              {option?.company_types?.filter(ele => ele?.order_id == 1)?.[0]?.['name']}
            </Grid>
            <Grid item xs={2}>
              {option?.hqcountry}
            </Grid>

            {option?.imdb_id && (
              <Grid item xs={3}>
                <>
                  <Chip
                    color="primary"
                    size="small"
                    icon={<MovieCreationIcon fontSize="inherit" />}
                    component={Link}
                    href={`https://www.imdb.com/name/${option?.imdb_id}`}
                    target="_blank"
                    label="IMDB"
                  />
                </>
              </Grid>
            )}

            {option?.person_tmdb_id && (
              <Grid item xs={3}>
                <>
                  <Chip
                    size="small"
                    color="secondary"
                    label="TMDB"
                    icon={<MovieCreationIcon fontSize="inherit" />}
                    component={Link}
                    href={`https://www.themoviedb.org/person/${option?.person_tmdb_id}`}
                    target="_blank"
                  />
                </>
              </Grid>
            )}
          </Grid>
        )}
        loading={loading}
        loadingText={
          'Searching ... '
        }
        value={company}
        onChange={(evt, v) => setCompany(v)}
        onInputChange={(evt, v) => {
          if (freeSolo) {
            if (!multiple) {
              if (company) {
                if (company && company.vtr_company_name !== v) {
                  setCompany(v);
                }
              } else {
                setCompany(v);
              }
            }
          }
        }}
        renderInput={props => (
          <TextField
            label={"Search a Company"}
            placeholder={"Search a Company"}
            fullWidth
            variant="outlined"
            {...props}
            onChange={ev => {
              if (!!ev.target.value) {
                debouncedOnChangeHandle(ev.target.value);
              }
            }}
            onFocus={ev => {
              if (!!ev.target.value) {
                debouncedOnChangeHandle(ev.target.value);
              }
            }}
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <>
                      <CircularProgress color="inherit" size={20} />
                      {props.InputProps.endAdornment}
                    </>
                  ) : (company?.vtr_company_name) ? (
                    <>
                      {props.InputProps.endAdornment}
                      <OfflinePinIcon style={{ fontSize: '1.5em' }} color="primary" />
                    </>
                  ) : null}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
      <div
        className={
          personCount == 0
            ? open
              ? classesForAvatarImage.personStatus
              : classesForAvatarImage.personStatus1
            : ''
        }>
      </div>
      <br />
      <DialogActions>
        <Button color="primary" onClick={ClickHandler} autoFocus>
          Save
        </Button>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function PersonStatus(props) {
  const { personData, createCompanyRelation = false} = props;
  if (personData == null || personData == 0) {
    return (
      <div style={{ marginTop: '0 !important' }}>
        <FormHelperText style={{ marginTop: '0 !important' }}>
          {createCompanyRelation ? "Person not available?" : "No Associated Person found?"} <Link component="button" onClick={props.showModal}>Create New</Link>
        </FormHelperText>
      </div>
    );
  }
  return <FormHelperText>Select the Associated Person</FormHelperText>;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    body: {
      "& > * iframe[style*='2147483647']": {
        display: 'none'
      },
      ".MuiAutocomplete-popper": {
        zIndex: '-1 !important'
      }
    },
    personStatus: {
      marginTop: theme.spacing(0),
    },
    personStatus1: {
      marginTop: theme.spacing(0),
    },
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    medium: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
    large: {
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
    paper: { minWidth: '500px', margin: '10px' },
    inputF: {
      margin: '20px',
      width: '450px',
    }
  })
);